import {useSelector} from 'react-redux';
import {selectUserId} from '../../../store/features/Auth/authSlice';
import {useFetchCurrentUserQuery} from '../../../store/features/Users/userService';
import {getFullName} from '../../../utilis/getFullName';
import type {CallIdentity} from '../model/types';

export const useSelfIdentity = (): CallIdentity => {
    const userId = useSelector(selectUserId);
    const {data: user} = useFetchCurrentUserQuery(userId, {skip: !userId});
    return {
        name: getFullName(user?.firstName ?? '', user?.lastName ?? '').trim() || undefined,
        avatarUrl: user?.avatarUrl || undefined,
        userId: userId ? String(userId) : undefined,
    };
};
